import * as React from 'react';

const Circulation = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.5 8.33325H17.5" stroke="#00AFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10 14.5833L11.25 15.8333"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 17.0833L11.25 15.8333"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5.41663L8.75 4.16663"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 2.91663L8.75 4.16663"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 15.8333H4.16667C3.24583 15.8333 2.5 15.0875 2.5 14.1666V5.83329C2.5 4.91246 3.24583 4.16663 4.16667 4.16663H5.83333"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 4.16663H15.8333C16.7542 4.16663 17.5 4.91246 17.5 5.83329V14.1666C17.5 15.0875 16.7542 15.8333 15.8333 15.8333H14.1667"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default Circulation;
